import React from "react";
import DesktopNav from "../DesktopNav";
import MobileNav from "../MobileNav";
// import Banner from "../Banner";

function Header() {
	return (
		<>
			{/* <Banner
				text="Join us for Ecomm Forum on October 12th"
				link="https://ecommforummpls.com/"
			/> */}
			<DesktopNav />
			<MobileNav />
		</>
	);
}

export default Header;
